import { Product, ProductKey } from "app/shared/model/ProductBase";
import DateHelper from "./dateHelper";
import { fi } from "date-fns/locale";

const searchAllData = <T extends Product>(searchableData: T[], searchValue: string): Product[] => {
    let fields:Array<keyof T> = [];

    if(searchableData && searchableData.length > 0)
    {
        for(const [key, value] of Object.entries(searchableData[0]!)) {
            if(!key.toLowerCase().includes("date") && !key.toLowerCase().includes("division"))
            {
                if(key.endsWith("Text"))
                {
                    var fieldIndex = fields.findIndex(f => f === key.replace("Text", ""));
                    if(fieldIndex != -1)
                    {
                        fields[fieldIndex] = key as keyof T;
                    }
                }

                fields.push(key as keyof T);
            }
        };
        
        return searchFields(searchableData, searchValue, fields);
    }

    return searchableData;
}

const searchFields = <T, >(searchableData:T[], searchValue: string, searchableFields: Array<keyof T>) => {
    if(searchableData && searchableData.length > 0)
    {
        let id = parseInt(searchValue); 

        searchableData = searchableData.filter((currentElement) => { 
            let match:boolean = false;
            
            searchableFields.forEach(field => {
                if(currentElement!.hasOwnProperty(field))
                {
                    if(!match && typeof(currentElement[field]) === "number" && !isNaN(id))
                    {
                        match = (currentElement[field] as unknown as number === id);
                    }

                    if(!match && typeof(currentElement[field]) === "string" && isNaN(Date.parse(currentElement[field] as unknown as string)))
                    {
                        match = (currentElement[field] as unknown as string).toLowerCase().includes(searchValue.toLowerCase());
                    }

                    if(!match && typeof(currentElement[field]) === 'object' && !isNaN(Date.parse(currentElement[field] as unknown as string)))
                    {
                        let fieldDate = new Date(currentElement[field] as unknown as string);
                        match = DateHelper.ToDateString(fieldDate).includes(searchValue);
                    }

                    if(!match && currentElement[field] === null && searchValue === undefined)
                    {
                        match = (currentElement[field] === null && searchValue === undefined);
                    }
                }
            });

            return match;        
        });
    }

    return searchableData;
}

const searchHelper = {searchFields, searchAllData};

export default searchHelper;